/**
 * CollapsedSidebarStrip - Minimal strip shown when sidebar is collapsed
 * Shows a button to expand the sidebar
 */

import React from "react";
import { FaChevronLeft, FaChevronRight } from "../../utils/icons";

interface CollapsedSidebarStripProps {
  side: "left" | "right";
  onExpand: () => void;
  shortcutHint?: string;
}

export const CollapsedSidebarStrip: React.FC<CollapsedSidebarStripProps> = ({
  side,
  onExpand,
  shortcutHint,
}) => {
  const isLeft = side === "left";

  return (
    <div
      className={`
        w-6 shrink-0 h-full
        sidebar-premium
        ${isLeft ? "sidebar-premium-border-r" : "sidebar-premium-border-l"}
        flex flex-col items-center justify-center
      `}
    >
      <button
        onClick={onExpand}
        className="
          p-1.5 rounded-lg
          text-fg-muted hover:text-white
          hover:bg-white/10
          transition-all duration-200
        "
        title={`Expand ${side} panel${shortcutHint ? ` (${shortcutHint})` : ""}`}
      >
        {isLeft ? <FaChevronRight className="w-3 h-3" /> : <FaChevronLeft className="w-3 h-3" />}
      </button>
    </div>
  );
};

export default CollapsedSidebarStrip;
